import React from 'react';
import './software-box-cta.styles.scss';

import { SANGEA_LINK } from '../../../../js/api/_config';

function SoftwareBoxCTA({
  title,
  className,
  smallBoxCta,
  subTitle,
  content,
  link,
  color,
  categories,
  transparent,
  isFromSoftware,
  selected
}) {

  console.log(title,"===title");
  
  // Determine href and target based on title
  let href = link;
  let target = '_self';
  if (title === 'SANGEA') {
    href = SANGEA_LINK;
    target = '_blank';
  } else if (title === 'TankESP') {
    href = 'https://shop.trinityconsultants.com/software/tanks/esp';
    target = '_self';
  }

  return (
    <a
      className={`
                ${className || ''}
                software-box-cta custom-border xs-only-trinity-container
                ${transparent ? 'transparent' : ''} 

                ${smallBoxCta ? 'small-software-box-cta' : ''}
                ${color}
            `}
      href={href}
      target={target}
      rel="noreferrer"
    >
      {title && (
        <div className="title">
          <div dangerouslySetInnerHTML={{ __html: title }} />{' '}
          {/* NL # TASK 40 */}
          {smallBoxCta && <span className="arrow d-none d-sm-inline">›</span>}
        </div>
      )}
      {subTitle && <div className="sub-title">{subTitle}</div>}
      {content && isFromSoftware ? (
        <div className="custom-block">{content}</div>
      ) : (
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {/* {link ? (
        <div className="bottom-link">
          <span className="link-text">
            Learn More <span className="arrow">›</span>
          </span>
        </div>
      ) : (
        ''
      )} */}
    </a>
  );
}

export default SoftwareBoxCTA;
